import React from 'react'

import { ReactComponent as GenericError } from 'assets/images/generic-error.svg'
import styles from './NoData.module.sass'
import ReactMarkdown from 'react-markdown'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

const NoData = (props) => {
	const { className, message, ...attributes } = props
	return (
		<Widget
			{...attributes}
			className={`${styles['root'] || ''} ${className || ''}`}
		>
			<GenericError className={styles['graphics']} />
			<div>
				<ReactMarkdown
					className={styles['message']}
					children={message}
				/>
			</div>
		</Widget>
	)
}

export default NoData
